import {Text, View} from 'native-base';
import React from 'react';
import Icon from 'react-native-vector-icons/FontAwesome5Pro';
import {useTheme} from 'styled-components/native';

export interface DomMarketBannerPropsTypes {
  destination: string | undefined;
}

const DomMarketBanner: React.FC<DomMarketBannerPropsTypes> = ({
  destination,
}) => {
  const theme = useTheme();
  return (
    <View
      flexDirection="row"
      height="14px"
      alignItems="center"
      justifyContent="flex-start"
      mb="4px">
      <Icon size={11} solid color={theme.colors.info} name="location" />
      <Text ml="4px" fontSize="11px" fontWeight="bold" color="info">
        {destination}
      </Text>
    </View>
  );
};

export default DomMarketBanner;
